import React, { memo } from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import NumberFormat from 'components/number_format';
import { checkPriceDiffer } from '../lib';
import DownArrowIcon from '../assets/images/down-arrow.png';
import UpArrowIcon from '../assets/images/incr-arr.png';
import EqualArrowIcon from '../assets/images/2arr-yel.png';
import useRewriteUrl from '../hooks/useRewriteUrl';

const priceStyle = priceDifference => ({
  color: priceDifference > 0 ? '#1CC619' : '#ef4923',
});

const SidebarMarket = memo(props => {
  useRewriteUrl();
  return (
    <div className="gctt-box mkt-prod" style={{ border: '1px solid #e1e1e1' }}>
      <div className="title text-center mt-3">
        <h4 className="mb-0 fw-bold text-uppercase">Giá cả thị trường</h4>
        <small className="primary-clr fw-semibold">
          Hôm nay, <span>{moment().format('DD.MM - hh:mm A')}</span>
        </small>
      </div>
      <table className="table">
        <thead>
          <tr>
            <th scope="col">Sản phẩm</th>
            <th scope="col" className="text-center">
              Giá
            </th>
            <th scope="col" className="text-center">
              Khu vực
            </th>
          </tr>
        </thead>
        <tbody>
          {props.data.map((market, index) => {
            const priceDifference = market.get_market_price_last?.price_difference || 0;
            if (market?.item_type === 'ad') {
              let externalLink = null;
              if (!!market.connect_link){
                externalLink = market.connect_link.startsWith('http') ? market.connect_link : 'http://' + market.connect_link;
              }
  
              return (
                <tr key={index}>
                  <td>
                    {!!externalLink ? (
                      <a
                        href={externalLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="d-block text-decoration-none"
                      >
                        <div className="fw-semibold line-clamp-02">{market.title}</div>
                      </a>
                    ) : (
                      <div className="fw-semibold line-clamp-02">{market.title}</div>
                    )}
                  </td>
                  <td colSpan={2} className="text-right">
                    <div className="text-secondary">
                      <small className="opacity-50 d-block mt-1">Được tài trợ</small>
                    </div>
                  </td>
                </tr>
              );
            }

            return (
              <tr key={index}>
                <td>
                  <Link to={`/chuyen-muc/thong-tin-gia-ca-thi-truong/${market.slug || market.id}`}>
                    <div className="fw-semibold line-clamp-02">{market.title}</div>
                  </Link>
                </td>
                <td className="text-right">
                  <div className="fw-semibold fs-12">
                    <div>
                      <NumberFormat>{market.get_market_price_last?.price}</NumberFormat>
                      <span style={{ marginLeft: '2px' }}>&nbsp;đ</span>
                    </div>
                  </div>
                  <span className="redu-pri fs-10" style={priceStyle(priceDifference)}>
                    <img
                      src={priceDifference !== 0 ? (priceDifference > 0 ? UpArrowIcon : DownArrowIcon) : EqualArrowIcon}
                      style={{ width: '10px', height: '10px', marginBottom: '2px' }}
                      alt="price-icon"
                    />
                    {priceDifference !== 0 && (
                      <span className="font-italic">
                        {priceDifference > 0 && '+'}
                        <NumberFormat>{checkPriceDiffer(priceDifference)}</NumberFormat> đ
                      </span>
                    )}
                  </span>
                </td>
                <td className="text-center text-secondary">{market.province_name}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <Link to={`/chuyen-muc/gia-ca-thi-truong`} className="more-btn-fll text-center d-block">
        <u>Xem thêm</u>
      </Link>
    </div>
  );
});

export default SidebarMarket;
